import UserEmailForm from './Content';
import UserEmailFormLayout from './Layout';
import { UserEmailFormProps } from './props';

/**
 * UserEmailFormRenderer Component
 * This component is responsible for rendering the user email form.
 * It decides whether to use a minimal form or a full form layout based on the provided props.
 *
 * @param {UserEmailFormProps} props - The properties for the component.
 * @param {boolean} props.isContainerColor - Indicates if the container should have a color.
 * @param {boolean} props.useMinimalForm - Indicates if the minimal form should be used.
 *
 * @returns {JSX.Element} The rendered user email form component.
 *
 * @example
 * // Usage example:
 * <UserEmailFormRenderer
 *   isContainerColor={true}
 *   useMinimalForm={false}
 * />
 */
export default function UserEmailFormRenderer({
  isContainerColor,
  useMinimalForm,
}: UserEmailFormProps) {
  if (useMinimalForm) {
    return (
      <UserEmailForm
        useMinimalForm={useMinimalForm}
        isContainerColor={isContainerColor}
      />
    );
  }

  return (
    <UserEmailFormLayout
      isContainerColor={isContainerColor}
      useMinimalForm={useMinimalForm}
    >
      <UserEmailForm
        useMinimalForm={useMinimalForm}
        isContainerColor={isContainerColor}
      />
    </UserEmailFormLayout>
  );
}
